/* eslint-disable */
import api from "./groupsPlaceApi";
import store from '../store';

export default {
  name: 'presentationControls',
  cardChange(presentation, direction) {
    store.dispatch("setExecuting", true)
    api.post("/presentationViewer/cardChange/" + presentation.sessionId, {
      token: presentation.accessToken, direction: direction
    }).then(
      () => {
        presentation.lastError = null
      },
      (error) => {
        presentation.lastError = error.response.data
      }).then(() => {
      store.dispatch("setExecuting", false)
    })
  },
  openToAnswer(presentation,isOpen) {
    store.dispatch("setExecuting", true)
    api.post("/presentationViewer/openToAnswer/" + presentation.sessionId, {
      token: presentation.accessToken, isOpen: isOpen
    }).then(
      () => {
        presentation.lastError = null
      },
      (error) => {
        presentation.lastError = error.response.data
      }).then(() => {
      store.dispatch("setExecuting", false)
    })
  },
  togglePause(presentation) {
    store.dispatch("setExecuting", true)
    api.post("/presentationViewer/togglePause/" + presentation.sessionId, {
      token: presentation.accessToken
    }).then(
      () => {
        presentation.lastError = null
      },
      (error) => {
        presentation.lastError = error.response.data
      }).then(() => {
      store.dispatch("setExecuting", false)
    })
  },
  terminateSession(presentation) {
    store.dispatch("setExecuting", true)
    api.post("/presentationViewer/terminate/" + presentation.sessionId, {token: presentation.accessToken}).then(
      () => {
        localStorage.removeItem("lastPresentationToken")
        presentation.lastError = null
      },
      (error) => {
        presentation.lastError = error.response.data
      }).then(() => {
      store.dispatch("setExecuting", false)
    })
  },
};
